import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';

const PickingListItemSupplier = (props) => {
    return (
        <Link
            className="row"
            style={{ display: 'block' }}
            to={props.route}
            onClick={(event) => {
                if (props.onSelectChange) {
                    props.onSelectChange(event);
                }
            }}
        >
            <div className="input-field col s12">
                <strong><span className="title sixth-text-color">{`${props.data.key}`}</span></strong>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{props.data.value}</span>
            </div>
        </Link>
    );
};

export default withRouter(withTranslation()(PickingListItemSupplier));
